/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TestCacheEntriesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Deletes the application cache entries.
     * @returns void
     * @throws ApiError
     */
    public testCacheEntries(): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/test/cache-entries',
            errors: {
                401: `Internal-Server-Error`,
                404: `Internal-Server-Error`,
                500: `Internal-Server-Error`,
            },
        });
    }

}
